export default "__VITE_ASSET__TH8BA_HP__"